import { render, staticRenderFns } from "./AllApprovalTask.vue?vue&type=template&id=b3e21c6c&scoped=true&"
import script from "./AllApprovalTask.vue?vue&type=script&lang=js&"
export * from "./AllApprovalTask.vue?vue&type=script&lang=js&"
import style0 from "./AllApprovalTask.vue?vue&type=style&index=0&id=b3e21c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e21c6c",
  null
  
)

export default component.exports